



































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import TableForm from '@/components/common/TableForm.vue'
import SearchForm from '@/components/common/SearchForm.vue'
import StatusReceipt from '@/components/common/StatusReceipt.vue'
import PayStatusReceipt from '@/components/common/PayStatusReceipt.vue'
import LendingDialog from './LendingDialog.vue'
import $Api from '@api'
import store from '@/store'
import { finalize, map } from 'rxjs/operators'
import { translate, DateTime } from '@/utils/filters'
import { payStatusMap, receiptStatusMap, oprTypeMap, businessParamMap} from '@/utils/status-map'
import { UtilsIndex } from '@/utils'
import { Channel } from '@/api/model/channel'

@Component({
    components: {
        SearchForm,
        TableForm,
        LendingDialog,
        StatusReceipt,
        PayStatusReceipt
    }
})
export default class extends Vue {
    dateTime = DateTime
    UtilsIndex = UtilsIndex

    PayStatusMap = payStatusMap
    ReceiptStatusMap = receiptStatusMap
    OprTypeMap = oprTypeMap
    BusinessParamMap = businessParamMap
    channelOptions: Channel[] = []

    showSearchForm = true
    searchForm: any = {
        current: 1,
        size: 10,
        closeTimeStart: null,
        closeTimeEnd: null,
        closeDate: [],
        createDate: [],
        loanId: null,
        identity: null,
        cameraId: null,
        phone: null,
        cardno: null,
        payStatus: null,
        realname: null,
        createTimeStart: null,
        createTimeEnd: null,
        detailId: null,
        oprType: null,
        channelId: null
    }

    tableLoading = false
    tableData = []
    total = 0
    actionArray: any[] = []
    ids = ''

    formProp = {}
    show = false
    disable = false
    formData = {}
    totalAmount: any = 0

    payStatusOptions = payStatusMap.createArray()

    oprTypeOptions = [
        { value: 0, label: translate('channel.manualLending') },
        { value: 1, label: translate('channel.systemLending') }
    ]

    businessParamOptions = [
        { value: 0, label: translate('channel.firstLoan') },
        { value: 1, label: translate('channel.doubleLoan') }
    ]

    @Watch('searchForm.closeDate')
    onCloseTimeChange(date: [Date, Date]): void {
        this.convertFormDate(date, ['closeTimeStart', 'closeTimeEnd'])
    }

    @Watch('searchForm.createDate')
    onCreateTimeChange(date: [Date, Date]): void {
        this.convertFormDate(date, ['createTimeStart', 'createTimeEnd'])
    }

    convertFormDate(date: [Date, Date], props: [string, string]) {
        const [startProp, endProp] = props
        this.searchForm[startProp] = null
        this.searchForm[endProp] = null
        if (date) {
            const [startDate, endDate] = date
            if (startDate) {
                this.searchForm[startProp] = startDate.getTime()
            }
            if (endDate) {
                this.searchForm[endProp] = endDate.getTime()
            }
        }
    }

    get isModify() {
        return this.actionArray.length === 1
    }

    /** 按钮状态(启用/禁用)判断 */

    get isCanChange() {
        if (this.actionArray.length === 0) {
            return false
        }
        return this.actionArray.every(item => item.isCanChange)
    }

    get isCanRepay() {
        if (this.actionArray.length === 0) {
            return false
        }
        return this.actionArray.every(item => item.isCanRepay)
    }

    get isCanCancel() {
        if (this.actionArray.length === 0) {
            return false
        }
        return this.actionArray.every(item => item.isCanCancel)
    }

    get isCanLoan() {
        if (this.actionArray.length === 0) {
            return false
        }
        return this.actionArray.every(item => item.isCanLoan)
    }

    get isCanFail() {
        if (this.actionArray.length === 0) {
            return false
        }
        return this.actionArray.every(item => item.isCanFail)
    }

    markHandler(data) {
        data.list.map(item => {
            // 可以点击【放款成功】的条件：（该单据为手动放款   且  （未付款  或者  支付失败）） 或者 （该单据为系统放款   且   支付失败）
            item.isCanLoan = (item.oprType === 0 && (item.payStatus === 0 || item.payStatus === 4)) || (item.oprType === 1 && item.payStatus === 4)
            // 【重新放款】按钮有效条件：系统放款  且  付款失败（4）；
            item.isCanRepay = item.oprType === 1 && item.payStatus === 4
            // 3、【取消放款】按钮有效条件：除了（付款中（1） 或者 待处理（2）  或者  付款成功（3） 或者 已取消（7））其他所有条件；
            item.isCanCancel = item.payStatus !== 1 && item.payStatus !== 2 && item.payStatus !== 3 && item.payStatus !== 7
            // 4、【放款失败】按钮有效条件：未付款（0）处理中（3）；
            item.isCanFail = item.payStatus !== 0 || item.payStatus !== 3
            item.isCanChange = (item.oprType === 0 && (item.payStatus === 0 || item.payStatus === 4))
            return item
        })
        return data
    }

    getData(pageQuery: any = {}) {
        this.searchForm.current = pageQuery.current ? pageQuery.current : this.searchForm.current
        this.searchForm.size = pageQuery.size ? pageQuery.size : this.searchForm.size
        const { createDate, closeDate, ...params } = this.searchForm
        this.tableLoading = true

        // $Api.receiptService
        //     .abroadPaymentListAmount(Object.assign(params, pageQuery))
        //     .subscribe(data => {
        //         this.totalAmount = data
        //     })

        $Api.receiptService
            .abroadPaymentList(Object.assign(params, pageQuery))
            .pipe(
                finalize(() => {
                    this.tableLoading = false
                })
            )
            .pipe(
                map(data => this.markHandler(data))
            )
            .subscribe(data => {
                this.tableData = data.list
                this.total = data.total
            })
    }

    onSearchSubmit() {
        this.searchForm.current = 1
        this.getData()
    }

    view(row = {}) {
        const { cameraId, id, amount, realname, cardno, ifscCode  } = row as any
        const { from } = this.$route.query
        /**
         * 从其他页面跳转放款详情页面时
         * 保持原菜单状态不动
         * 其他页面：
         * - 放款管理-放款明细页面：credit-loan-record
         */
        if (from === 'credit-loan-record') {
            this.$router.push({
                name: 'loan/lending/detail', query: { cameraId, id, amount, name: realname, cbu: cardno, cuit: ifscCode }
            })
        } else {
            this.$router.push({
                name: 'receipt/lending/detail', query: { cameraId, id, amount, name: realname, cbu: cardno, cuit: ifscCode }
            })
        }
    }

    confirmChanageOprType() {
        this.showDialog(this.$t('channel.isConfirmChangeOprType') as string, async () => {
            const params = this.getRequestParams()
            $Api.receiptService.changeOprType(params).subscribe(() => {
                this.$message.success('Success!')
                this.getData()
            })
        })
    }

    lendingAgain() {
        this.showDialog(this.$t('channel.isConfirmLendingAgain') as string, async () => {
            const params = this.getRequestParams()
            $Api.receiptService.payResend(params).subscribe(() => {
                this.$message.success('Success!')
                this.getData()
            })
        })
    }

    cancelLending() {
        this.showDialog(this.$t('channel.isConfirmCancelLending') as string, async () => {
            const params = this.getRequestParams()
            $Api.receiptService.payReject(params).subscribe(() => {
                this.$message.success('Success!')
                this.getData()
            })
        })
    }

    confirmTheLoan() {
        this.show = true
        this.$nextTick(() => {
            ;(this.$refs['LendingDialogRef'] as any).setForm(this.getRequestParams())
        })
    }

    confirmTheLoanFailure() {
        this.showDialog(this.$t('channel.isConfirmTheLoanFailure') as string, async () => {
            const params = this.getRequestParams()
            $Api.receiptService.payFail(params).subscribe(() => {
                this.$message.success('Success!')
                this.getData()
            })
        })
    }

    exportLoan() {
        if (this.total > 10000) {
            this.$message.error('数据过多，请重新查询。')
        } else {
            $Api.receiptService.exportAbroadPaymentList(this.searchForm).subscribe()
        }
    }

    getRequestParams() {
        const { ids } = this
        const { userName } = store.getters
        return {
            ids,
            userName
        }
    }

    confirmLending() {
        this.getData()
        this.show = false
    }

    // 弹出提示框
    showDialog(title: string, callback: Function) {
        this.$confirm(title, {
            confirmButtonText: this.$t('common.btn.confirm') as string,
            cancelButtonText: this.$t('common.btn.cancel') as string,
            type: 'warning'
        })
            .then(() => {
                callback()
            })
            .catch(() => {
            })
    }

    // 表格项选中
    handleSelectionChange(selectedArray: any) {
        this.actionArray = selectedArray
        this.ids = this.actionArray.map(item => item.id).join(',')
    }

    created() {
        const { cameraId, phone = '' } = this.$route.query
        if (cameraId) {
            this.searchForm.cameraId = cameraId
            this.showSearchForm = false
        }
        this.searchForm.phone = phone
        this.getData()
        this.getChannels()
    }

    get country() {
        return (this.$store.state.auth.authInfo || {}).country
    }
    getBankCardType(value){
        if(value === 0){
            return 'CA'
        }else if(value === 1){
            return 'CC'
        }
    }
    getChannels() {
        $Api.channelService.queryChannelDropdown().subscribe(data => {
            this.channelOptions = data
        })
    }
}
